import { render, staticRenderFns } from "./RecordAppointment.vue?vue&type=template&id=55650d17"
import script from "./RecordAppointment.vue?vue&type=script&lang=js"
export * from "./RecordAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55650d17')) {
      api.createRecord('55650d17', component.options)
    } else {
      api.reload('55650d17', component.options)
    }
    module.hot.accept("./RecordAppointment.vue?vue&type=template&id=55650d17", function () {
      api.rerender('55650d17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/RecordAppointment.vue"
export default component.exports